import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { EMPTY, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { BusinessCard, StatClick } from '@app-model/businessCard';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
	providedIn: 'root'
})
export class CardsService {
	constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {}

	getCards(currentUrl: string): Observable<BusinessCard> {
		const headers = new HttpHeaders().set('X-MBC-Origin-Path', currentUrl);

		return this.http.get<BusinessCard>(`${environment.api}/open/businessCard`, { headers });
	}

	getClientPreviewCard(clientId: string): Observable<BusinessCard> {
		return this.http.get<BusinessCard>(`${environment.api}/cardholder/cardholderInfo?clientId=${clientId}`);
	}

	getGroupPreviewCard(id: string, type: string): Observable<BusinessCard> {
		let url = `${environment.api}/cardholder/cardholderInfo?groupId=${id}`;
		if (type === 'CLIENT') {
			url = `${environment.api}/cardholder/cardholderInfo?clientId=${id}`;
		}
		if (type === 'CARDHOLDER') {
			url = `${environment.api}/cardholder/cardholderInfo?cardholderId=${id}`;
		}
		return this.http.get<BusinessCard>(url);
	}

	getCardholderPreviewCard(clientId: string, groupId?: string): Observable<BusinessCard> {
		let url = groupId
			? `${environment.api}/cardholder/cardholderInfo?clientId=${clientId}&groupId=${groupId}`
			: `${environment.api}/cardholder/cardholderInfo?clientId=${clientId}`;

		return this.http.get<BusinessCard>(url);
	}

	pageView(uuid: string, currentUrl: string): Observable<any> {
		if (!isPlatformBrowser(this.platformId)) {
			return EMPTY;
		}

		const headers = new HttpHeaders().set('X-MBC-Origin-Path', currentUrl).set('X-MBC-AccessId', uuid);
		const body: any = {};

		return this.http
			.post(`${environment.api}/stats/pageview`, body, { headers })
			.pipe(map((response: any) => response));
	}

	statsClick(uuid: string, currentUrl: string, body: StatClick): Observable<any> {
		const headers = new HttpHeaders().set('X-MBC-Origin-Path', currentUrl).set('X-MBC-AccessId', uuid);

		return this.http.post(`${environment.api}/stats/click`, body, { headers }).pipe(
			map((response: any) => {
				return response;
			})
		);
	}
}
